import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProvisionWizard from '../components/ProvisionWizard';

/**
 * 统一开通向导页:/user/provision/:productType
 * (host_shared / host / lightapp / yeapmail / evm)。各产品"创建/添加"入口跳到这里。
 */
export default function Provision() {
    const { productType } = useParams();
    const [sp] = useSearchParams();
    // 域名赠品兑换：/provision/:type?gift_grant_id=&product_id=&billing_cycle=（套餐与周期由赠品决定）
    return (
        <div style={{ padding: 16 }}>
            <ProvisionWizard key={`${productType}:${sp.get('mode') || ''}`} productType={productType} giftGrantId={sp.get('gift_grant_id')}
                presetProductId={sp.get('product_id')} presetCycle={sp.get('billing_cycle')}
                presetMode={sp.get('mode')} presetVariant={sp.get('variant')} />
        </div>
    );
}
